import { render, staticRenderFns } from "./outcome.vue?vue&type=template&id=021ba9e4&scoped=true&"
import script from "./outcome.vue?vue&type=script&lang=js&"
export * from "./outcome.vue?vue&type=script&lang=js&"
import style0 from "./outcome.vue?vue&type=style&index=0&id=021ba9e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021ba9e4",
  null
  
)

export default component.exports